import messages from '../../modals/manualPaymentModal/ManualPaymentModal.messages';
import DashboardLink from '../../navigation/DashboardLink';
import { FormattedMessage } from 'react-intl';
import styles from './TruelayerConfirmation.module.css';
import { MoneyWithDecimals } from '../../ui/moneyWithDecimals';
import { Icon } from '@iwoca/orion';
import { Prompt } from '../../ui/prompt';

export const PaymentSuccessful = ({
    paymentReference,
    amount
}: {
    paymentReference: string;
    amount: number;
}) => (
    <>
        <div className={styles.confirmationContainer}>
            <Icon icon="checkCircleFilled" className={styles.successIcon} />
            <div
                className={styles.primaryContent}
                data-testid="amount-container"
            >
                Thanks, we’ve received your payment of
                <div className={styles.amount}>
                    <MoneyWithDecimals value={amount} />
                </div>
                Your outstanding balance may take a moment to update
            </div>
            <div
                className={styles.secondaryContent}
                data-testid="reference-container"
            >
                You’ll receive an email confirmation shortly <br />
                Payment reference: {paymentReference}
            </div>
        </div>
        <Prompt className={styles.prompt}>
            <DashboardLink isButton={true}>
                <FormattedMessage {...messages.returnToDashboard} />
            </DashboardLink>
        </Prompt>
    </>
);
